module.exports = __webpack_public_path__ + "static/mark-skiing-7915a144c6e561aa5dc0eb47896d0a24.jpg";